module.exports = __webpack_public_path__ + "static/img/empty-team.f08da60e.png";